import type { FaireProductEntity } from "../../entity_types/product";

export const p_uz44vt25zg: FaireProductEntity = {
  token: "p_uz44vt25zg",
  type: "product",
  name: "Emerald Zodiac Necklace Gemini May Birthstone Charm Necklace",
  brandToken: "b_t2f2m59z3d",
  brandName: "El Joyero",
  imageUrl:
    "https://cdn.faire.com/fastly/3702ec95a25ae978c3fe38bc72f8cf1f28c47ed887fc13a12538e5ffd04da784.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/cb5e4ddee247769654561529f639b687939f58c1f3ca0eed1d8d2079900207bb.png",
    "https://cdn.faire.com/fastly/0a389217ff644ca33cdbcc5d26d1338d135c0579c216e213a4ee2a6454bf5560.jpeg",
    "https://cdn.faire.com/fastly/15fca677f4c56817b55d7e577ccfc3c4f5b7c449074f10c3c6ddd74470f4fffc.jpeg",
    "https://cdn.faire.com/fastly/3e7782907e6a33a1fb25c30b0d4ce70abcf64ae8de1758c30987c2e1a6697ab0.jpeg",
    "https://cdn.faire.com/fastly/37dad8a5c31f916024857b29d12eb0a9bb0c259f05b90267372bd477e8eea927.png",
  ],
  priceDollars: 8.95,
  description:
    "Celebrate May birthdays and Gemini energy with this Raw Emerald Gemini Zodiac Necklace. Known as the May birthstone, emerald represents growth, harmony, and wisdom—perfectly aligned with the curious and adaptable spirit of Gemini. This handmade necklace features a raw emerald gemstone with a zodiac coin charm, making it a stylish and meaningful piece of astrology-inspired jewelry.\n\nDetails:\n\nMaterial: Brass\nPlating: Gold Plated\nGemstone: Raw Emerald (8–10mm)\nNecklace Length: 21 inches (adjustable threader)\nStyle: Zodiac Birthstone Jewelry\nCode: 504405\n\nFeatures:\n\nHandcrafted Design – Each necklace is artisan-made with a unique raw emerald.\n\nSymbolic & Meaningful – Emerald brings balance and wisdom, resonating with Gemini’s traits.\n\nDurable Materials – Gold-plated brass ensures shine and long-lasting quality.\n\nVersatile Style – A perfect statement piece or layering necklace.\n\nThoughtful Gift – Ideal for May birthdays, Geminis, or astrology lovers.",
  tags: [],
  msrpDollars: 15.76,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-06T18:02:06.653Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
